<template>
    <div>
        <v-card flat>
            <v-toolbar color="#303a55" dark extended flat>
            </v-toolbar>
            <v-card class="mx-auto pa-4" max-width="700" style="margin-top: -64px;">
                <v-img :src="require('./../assets/VULlogo.png')" width="100" height="100" class="mx-auto">
                </v-img>
                <v-card-title class="justify-center">Welcome to VUL</v-card-title>
                <v-card-subtitle class="text-center">FEE PAYMENT GATEWAY</v-card-subtitle>
                <v-card-text>
                    <v-container>
                        <v-text-field type="tel" label="Enter amount" outlined color="#303a55" dense v-model="amount">
                        </v-text-field>
                        <div id="paypal-button-container" class="text-center"></div>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-card>
        <snackbar :snackbar.sync="modal" :message.sync="message" v-on:closeSnackbar="modal=false"></snackbar>
        <Loading :loading="loading"></Loading>
    </div>
</template>

<script src="https://www.paypal.com/sdk/js?client-id=AT5UqQghDWS_02EONKBM9k0ODKNdQCoNLALre9TMkE2H32aCddSSC7Dy3xlX3zcbXr6lbZnd03THHn6A">
</script>

<script>
    import {FeeService} from './../services/FeeService.js';
    import Snackbar from './Snackbar.vue';
    import Loading from './Loading.vue';
    export default {
        data(){
            return{
                user: null,
                amount: '',
                modal: false,
                message: '',
                loading: false
            }
        },
        components:{
            Snackbar,
            Loading
        },
        methods: {
            createTransaction(pay){
                this.loading = true;
                FeeService.testpay(pay).then((response) => {
                    this.amount = '';
                    console.log(response);
                    this.loading = false;
                    this.modal = true;
                    this.message = response.data.message;
                }).catch((error) => {
                    console.log(error);
                    this.loading = false;
                    this.amount = '';
                    this.modal = true;
                    this.message = error.response.data.message;
                })
            }
        },
        mounted(){
            console.log(this.user);
            paypal.Buttons({
                createOrder: (data, actions) => {
                    return actions.order.create({
                        purchase_units: [
                            {
                                amount: {
                                    value: this.amount
                                }    
                            }
                        ]
                    });
                },
                onApprove: (data, actions) => {
                    return actions.order.capture().then((details) => {
                        console.log(details);
                        alert('Transaction completed by '+details.payer.name.given_name);
                        this.createTransaction({
                            "userid": this.user.id,
                            "orderid": details.id,
                            "intent": details.intent,
                            "payerid": details.payer.payer_id,
                            "payergivenname": details.payer.name.given_name,
                            "surname": details.payer.name.surname,
                            "emailid": details.payer.email_address,
                            "countrycode": details.payer.address.country_code,
                            "amount": details.purchase_units[0].amount.value,
                            "currencycode": details.purchase_units[0].amount.currency_code,
                            "transactionid": details.purchase_units[0].payments.captures[0].id,
                            "shippingaddressline": details.purchase_units[0].shipping.address.address_line_1,
                            "shippingadminarea1": details.purchase_units[0].shipping.address.admin_area_1,
                            "shippingadminarea2": details.purchase_units[0].shipping.address.admin_area_2,
                            "shippingcountrycode": details.purchase_units[0].shipping.address.country_code,
                            "shippingpostalcode": details.purchase_units[0].shipping.address.postal_code,
                            "shipto": details.purchase_units[0].shipping.name.full_name,
                            "create_time": details.create_time,
                            "update_time": details.update_time,
                            "status": details.status
                        });
                    });
                }
            }).render('#paypal-button-container');
        },
        created(){
            if(localStorage.getItem('user') == null){
                this.$router.push({name: 'student'});
            }
            else{
                this.user = JSON.parse(localStorage.getItem('user'));
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>